import PayPalButton from './PayPalButton';

export default PayPalButton;
